import React from "react";

import { Stack } from "@mui/material";
import { useTranslation } from "react-i18next";

import useStyles, { Logo, GridItemForm, CircularProgressStyled } from "./styles";

interface ApprovingScreenProps {
  logoSrc?: string;
}

export const ApprovingScreen = (props: ApprovingScreenProps) => {
  const { logoSrc } = props;
  const { t: translate } = useTranslation();
  const classes = useStyles();

  return (
    <GridItemForm
      item
      padding="52px 52px 0 52px"
      borderRadius="12px 0px 0px 12px"
      lg={12}
      height="inherit"
    >
      <Stack direction="column" height="100%">
        <Logo src={logoSrc} />
        <Stack alignItems="center" justifyContent="center" height="100%" spacing={2}>
          <div className={classes.loadingContainer}>
            <CircularProgressStyled className="circularProgress" />
          </div>
          <span className={classes.approvingMessage}>{translate("approvingCompany")}</span>
        </Stack>
      </Stack>
    </GridItemForm>
  );
};
